"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.profile.title': 'Edytuj Profil',
    'user.profile.back': 'Powrót do Pulpitu',
    'user.profile.name.label': 'Pełna Nazwa',
    'user.profile.name.placeholder': 'Jan Kowalski',
    'user.profile.username.label': 'Nazwa Użytkownika',
    'user.profile.username.placeholder': 'jankowalski',
    'user.profile.email.label': 'Email',
    'user.profile.email.placeholder': 'email@adres.pl',
    'user.profile.picture.label': 'Zdjęcie Profilowe',
    'user.profile.picture.placeholder': 'Wybierz zdjęcie profilowe...',
    'user.profile.picture.remove': '×',
    'user.profile.changePassword.title': 'Zmień Hasło',
    'user.profile.changePassword.description': 'Pozostaw pola hasła puste, jeśli nie chcesz zmieniać hasła.',
    'user.profile.password.new.label': 'Nowe Hasło',
    'user.profile.password.placeholder': 'Wprowadź nowe hasło',
    'user.profile.password.repeat.label': 'Powtórz Nowe Hasło',
    'user.profile.password.repeat.placeholder': 'Powtórz nowe hasło',
    'user.profile.submit': 'Zaktualizuj Profil',
    'user.profile.form.passwordMismatch': 'Hasła nie są zgodne',
    'user.profile.form.updateFailed': 'Błąd aktualizacji profilu',
    'user.profile.form.updateSuccess': 'Profil został pomyślnie zaktualizowany',
};
